module.exports = __webpack_public_path__ + "img/NA_1000_R.f94b822e.png";